'use client';

import { type MouseEvent, memo } from 'react';

import { BoardListItemRow } from '~/components/list/BoardListItemRow';
import { ClipListItemRow } from '~/components/list/ClipListItemRow';
import { type ListViewColumnField } from '~/constants/listViewColumns';
import { type ListViewItem } from '~/utils/formatItemsListResponse';

export type ListItemRowProps = {
  isSelected?: boolean;
  item: ListViewItem;
  onClick?: (item: ListViewItem, event: MouseEvent<HTMLButtonElement>) => void;
  onDoubleClick?: (item: ListViewItem, event: MouseEvent<HTMLButtonElement>) => void;
  visibleColumns: ListViewColumnField[];
};

export const ListItemRow = memo(({ isSelected, item, onClick, onDoubleClick, visibleColumns }: ListItemRowProps) => {
  if (item.type === 'board') {
    return (
      <BoardListItemRow
        isSelected={isSelected}
        item={item}
        onClick={onClick}
        onDoubleClick={onDoubleClick}
        visibleColumns={visibleColumns}
      />
    );
  }

  return (
    <ClipListItemRow
      isSelected={isSelected}
      item={item}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      visibleColumns={visibleColumns}
    />
  );
});

ListItemRow.displayName = 'ListItemRow';
